module.exports = __webpack_public_path__ + "img/r5-ur3.b8163931.jpg";